import { useRef, useCallback } from 'react';

export default function useDebounce(callback, delay) {
  const argsRef = useRef();
  const timeout = useRef();

  const debouncedFunction = useCallback(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      callback(...argsRef.current);
    }, delay);
  }, [callback, delay]);

  return (...args) => {
    argsRef.current = args;
    debouncedFunction();
  };
}
